export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            投稿爆料
          </h2>
          <p className="text-sm text-foreground-500 mb-8">
            你有独家内幕？欢迎向我们投稿爆料。请确保信息真实可靠，优质爆料一经采纳将注明供稿人信息。
          </p>

          <div className="bg-background-50 rounded-2xl p-8 md:p-10 border border-background-200/70">
            <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-primary-100 mb-5">
              <i className="ri-mail-send-line text-2xl text-primary-600" />
            </div>
            <h3 className="font-heading text-lg text-foreground-900 mb-2">
              投稿方式
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-5">
              将你的爆料内容发送至下方邮箱，请附上尽可能详细的描述和可查证来源。我们的编辑团队将在 24 小时内回复审核结果。
            </p>
            <div className="inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-background-100 border border-background-200/70 text-foreground-800 font-medium text-sm">
              <i className="ri-mail-line text-base text-primary-600" />
              tips@chiguaqun.com
            </div>
            <p className="text-xs text-foreground-500 mt-4">
              爆料人信息严格保密，支持匿名投稿。请勿提交未经核实的谣言内容。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}